//
// Copyright ArangoDB GmbH, Cologne, Germany
// All rights reserved. See LICENSE.md in the project root for license information.
//

const createHistory = require("history").createBrowserHistory;

export default createHistory();
